import classnames from 'classnames';

import { translation } from '@hh.ru/front-static-app';
import { H1, H2 } from 'bloko/blocks/header';
import Text, { TextImportance } from 'bloko/blocks/text';
import VSpacing from 'bloko/blocks/vSpacing';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';
import { format } from 'bloko/common/trl';

import { GridColumn, GridRow } from 'src/components/Grid';
import { NON_BREAKING_SPACE } from 'src/constants/symbols';

import styles from 'src/components/TechnicalWorks/technical-works.less';

const TrlKeys = {
    title: 'statportal.technicalWorks.title',
    text1: 'statportal.technicalWorks.text1',
    text2: 'statportal.technicalWorks.text2',
    date: 'statportal.technicalWorks.date',
    time: 'statportal.technicalWorks.time',
};

interface TechnicalWorksProps {
    TitleElement?: typeof H1 | typeof H2;
    date?: string;
    time?: string;
    substrate?: boolean;
}

const TechnicalWorks: TranslatedComponent<TechnicalWorksProps> = ({
    TitleElement = H2,
    date,
    time,
    substrate = false,
    trls,
}) => {
    return (
        <GridRow>
            <GridColumn m="8" l="8">
                <div
                    className={classnames(styles.technicalWorks, {
                        [styles.technicalWorksSubstrate]: substrate,
                    })}
                >
                    <div className={styles.technicalWorksText}>
                        <TitleElement>{trls[TrlKeys.title]}</TitleElement>
                        <VSpacing base={4} />
                        <Text>{trls[TrlKeys.text1]}</Text>
                        <VSpacing base={4} />
                        <Text>{trls[TrlKeys.text2]}</Text>
                        {date && (
                            <>
                                <VSpacing base={4} />
                                <Text Element="span" importance={TextImportance.Secondary}>
                                    {format(trls[TrlKeys.date], {
                                        '{0}': date,
                                    })}
                                </Text>
                                {time && (
                                    <>
                                        {NON_BREAKING_SPACE}
                                        <Text Element="span" importance={TextImportance.Secondary}>
                                            {format(trls[TrlKeys.time], {
                                                '{0}': time,
                                            })}
                                        </Text>
                                    </>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </GridColumn>
        </GridRow>
    );
};

export default translation(TechnicalWorks);
